/**
 * Hand-maintained logo-version pairs for the PDP logo-version test.
 *
 * Keyed by the ORIGINAL (grey logo) handle, valued with the UPDATED (new branding) one.
 * The direction is carried by the structure, so it never has to be inferred from a title
 * marker or from created_at, and the two directions cannot disagree — the reverse index is
 * built once in oa-logo-versions-api.js rather than entered twice here.
 *
 * Titles no longer carry a branding marker and these products no longer carry the
 * multiple-logo-versions tag, so the title and tag matching in oa-logo-versions-api.js can no
 * longer pair anything. This map is the only path left: a product absent from it does not pair
 * at all, and an unmapped colour of a mapped garment is dropped from the colour selector by
 * siblingColours. List every colour, not just the garment.
 *
 * What it does NOT override: a product that is preview-launch or coming-soon is still never
 * offered. Listing a pair says the two are the same garment, not that either is sellable.
 */
window.OA_LOGO_VERSION_PAIRS = {
  'enhancelift-seamless-minimal-halter-neck-bralette-with-grey-logo-black':
    'enhancelift-seamless-minimal-halter-neck-bralette-new-branding-black',
  'enhancelift-seamless-minimal-halter-neck-bralette-with-grey-logo-burnt-maroon':
    'enhancelift-seamless-minimal-halter-neck-bralette-new-branding-burnt-maroon',
  'enhancelift-seamless-minimal-halter-neck-bralette-with-grey-logo-plum-brown':
    'enhancelift-seamless-minimal-halter-neck-bralette-new-branding-plum-brown',
  'enhancelift-seamless-minimal-halter-neck-bralette-with-grey-logo-true-blue':
    'enhancelift-seamless-minimal-halter-neck-bralette-new-branding-true-blue',

  'enhancelift-seamless-strappy-sports-bra-with-grey-logo-black':
    'enhancelift-seamless-strappy-sports-bra-new-branding-black',
  'enhancelift-seamless-strappy-sports-bra-with-grey-logo-burnt-maroon':
    'enhancelift-seamless-strappy-sports-bra-new-branding-burnt-maroon',
  'enhancelift-seamless-strappy-sports-bra-with-grey-logo-plum-brown':
    'enhancelift-seamless-strappy-sports-bra-new-branding-plum-brown',
  'enhancelift-seamless-strappy-sports-bra-with-grey-logo-true-blue':
    'enhancelift-seamless-strappy-sports-bra-new-branding-true-blue'
}; 
